import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

function ButtonSwitch({ onChange, value }) {
  return (
    <div className={Styles.container}>
      <ClickableDiv
        onClick={() => onChange(true)}
        className={classNames(
          Styles.basicButton,
          { [Styles.selected]: !!value },
          { [Styles.unSelected]: !value },
        )}
      >
        <div>
          開啟
        </div>
      </ClickableDiv>
      <ClickableDiv
        onClick={() => onChange(false)}
        className={classNames(
          Styles.basicButton,
          { [Styles.selected]: !value },
          { [Styles.unSelected]: !!value },
        )}
      >
        <div>
          關閉
        </div>
      </ClickableDiv>
    </div>
  );
}

ButtonSwitch.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
};

ButtonSwitch.defaultProps = {
  value: false,
  onChange: () => {},
};

export default ButtonSwitch;
